export enum CurrencyTypeEnum {
  PERCENTAGE = 'PERCENTAGE',
  EURO = 'EURO',
}
